import { c as _c } from "react/compiler-runtime";
import { Text } from "@flat-ui";
import { Box } from "@mui-wrapper";
/** Shared layout that renders a step's title and subtext above its input controls. */
export function AnalyticsFeedbackStepLayout(t0) {
  const $ = _c(15);
  const {
    title,
    subtext,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "flex",
      flexDirection: "column",
      gap: 2
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "flex",
      flexDirection: "column",
      gap: 0.5
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== title) {
    t3 = <Text variant="heading16">{title}</Text>;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== subtext) {
    t4 = <Text variant="bodyM" color="text.secondary">{subtext}</Text>;
    $[4] = subtext;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <Box sx={t2}>{t3}{t4}</Box>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      display: "flex",
      flexDirection: "column",
      gap: 1
    };
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== children) {
    t7 = <Box sx={t6}>{children}</Box>;
    $[10] = children;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t5 || $[13] !== t7) {
    t8 = <Box sx={t1}>{t5}{t7}</Box>;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}